module.exports = __webpack_public_path__ + "a48f0628540fa02fd1468f61ab821eb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/iyv-thumbs/gff-thumbnail.jpg
// module id = 1969
// module chunks = 0